export class AzureBlobStorageDocument {
	cheminAzureBlobStorage: string | undefined
	identifiant: string | undefined;
	nom: string | undefined;
	url: string | undefined;

	constructor(cheminAzureBlobStorage?: string, identifiant?: string, nom?: string, url?: string) {
		this.cheminAzureBlobStorage = cheminAzureBlobStorage;
		this.identifiant = identifiant;
		this.nom = nom;
		this.url = url;
	}

	deserialize(input: any): this {
		return Object.assign(this, input);
	}
}
